import { clearCategories, deselectCategory, deselectQuestionTemplate, loadCategoriesQuestionsTree, loadCategoryNodes, selectCategory, selectQuestionTemplate, setSelectedCategoryIds } from "../../actions/categories";
import { CategoriesStore } from "../../stores/categories";
import { connect } from "../../utils/aj-react";
import { TreeSelector } from "./treeSelector";
import M from "../../strings"
import { Control } from "./forms";
import _ from "underscore";


export const QuestionsTreeSelector = connect(TreeSelector).to(CategoriesStore, 
    (state) => ({
        nodes: state.questionNodes,
        selectedNodes: state.selectedQuestionTemplateIds,
    }),
    (props) => ({
        onInit: (props) => {
            if (!props.manualLoad) {
                //loadCategoriesQuestionsTree(props.categoryIds);
            }
        },
        onDestroy: (props) => {
            if (!props.manualLoad) {
                //clearCategories();
            }
        },
        onUpdate: (props, state) => {
            if (_.isFunction(props.onUpdateQuestions)) {
                this.props.onUpdateQuestions(state.selectedQuestionTemplateIds);
            }
        },
        onSelect: node => selectQuestionTemplate(node),
        onDeselect: node => deselectQuestionTemplate(node),
    })
)
